import React, { Fragment } from "react";
import { Box } from "@mui/material";
import { ParagraphText, UBRadioBox } from "../../../../../Libraries";
import { RangePicker } from "../../../../common";

const FilterTabContent = ({
  I18n,
  isShowDateField,
  filterOp,
  setFilterOp,
  onFilterDate,
}) => {
  const PaymentFilter = ["All", "Paid", "Unpaid"];

  return (
      <Fragment>
        <Box className="accountFilterOptionRow">
          <ParagraphText className="optionBoxtitle">
            {I18n.filter}
          </ParagraphText>
          <Box className="filterRadioOptionList marginTop15">
            {PaymentFilter.map((pf, ind) => (
              <UBRadioBox
                key={ind}
                index={ind}
                label={pf}
                onChange={(value) => {
                  setFilterOp((f) => ({ ...f, payment: value }));
                }}
                value={filterOp.payment}
              />
            ))}
          </Box>
        </Box>
        {isShowDateField && (
          <Box className="accountFilterOptionRow">
            <ParagraphText className="optionBoxtitle">
              {I18n.date}
            </ParagraphText>

            <Box className="filterRadioOptionList marginTop15">
              <UBRadioBox
                index={0}
                label="Custom"
                onChange={(value) => {
                  setFilterOp((f) => ({
                    ...f,
                    dateType: value === f.dateType ? "" : "Custom", // toggle selection
                    startDate: "",
                    endDate: "",
                  }));
                }}
                value={filterOp.dateType}
              />

              {filterOp.dateType === "Custom" && (
                <Box
                  width="100%"
                  display="flex"
                  justifyContent="center"
                  marginTop="1rem"
                >
                  <RangePicker
                    onFilterDate={(startDate, endDate) => {
                      setFilterOp((f) => ({ ...f, startDate, endDate }));
                      onFilterDate(startDate, endDate);
                    }}
                    rangeValue={
                      filterOp?.startDate && filterOp?.endDate
                        ? [filterOp.startDate, filterOp.endDate]
                        : []
                    }
                  />
                </Box>
              )}
            </Box>
          </Box>
        )}
      </Fragment>
  );
};

export default FilterTabContent;
